import React from 'react';

import * as Form from 'tsui/Form';

import * as Api from 'api';

import {CardRowDisplayData} from '../CardsTab';
import PageDialog from '../../../tsui/PageDialog';
import CardDetailsBody from './CardDetailsBody';

interface CardsDetailsProps {
    cardId: string;
    onDetailsClose: (changed: boolean) => void;
}

export default function CardDetailsModal(props: CardsDetailsProps) {
    const changedFlag = React.useRef(false);

    // const [ownerData, setOwnerData] = React.useState<CardRowDisplayData | null>(null);
    // const form = Form.useUpdateForm();

    // const onData = React.useCallback((apiData: Api.ApiCard) => {
    //     setOwnerData(new CardRowDisplayData(apiData));
    // }, []);

    // const onSubmit = React.useCallback(() => {

    //     console.log('print front')
    //     Api.requestAdmin('admin', 'card_get_printer_status', {}).then(d => {

    //         if (d === true) {

    //             Api.requestAdmin('admin', 'card_print_image', { cardId: props.cardId }).then(d => {

    //             }).catch(err => console.log(err));

    //         } else {
    //             console.log('false')
    //         }

    //         // props.onClose()
    //     }).catch(err => console.log(err));
    //     // alert('congratulations')

    // }, []);

    // const onClick = React.useCallback(() => {

    //     console.log('print back')
    //     Api.requestAdmin('cards', 'get_printer_status', {}).then(d => {

    //         if (d === 0) {
    //             console.log('d', d)
    //             // Api.requestAdmin('admin', 'card_print_back', { cardId: props.cardId }).then(d => {
    //             Api.requestAdmin('cards', 'print_back', { cardId: props.cardId }).then(d => {

    //             }).catch(err => console.log(err));

    //         } else {
    //             console.log('false')
    //         }

    //         // props.onClose()
    //     }).catch(console.error);
    //     // alert('congratulations')

    // }, []);

    return (
        <PageDialog
            type='confirm'
            ttitle={`Card: ${props.cardId}`}
            onClose={() => props.onDetailsClose(changedFlag.current)}
        >
            <CardDetailsBody cardId={props.cardId} onChanged={() => (changedFlag.current = true)} />
        </PageDialog>
    );
}
